import { TContentType } from '@/types/Content.types';
import { HStack, Text } from '@chakra-ui/react';
import { getContentTypeLabel, TYPE_ICON, TYPE_ICON_COLOR } from './contentLabels';

// Content type as an icon + label (icons match the create type picker).
const ContentTypeBadge = ({ type }: { type: TContentType }) => {
  const Icon = TYPE_ICON[type];
  return (
    <HStack as="span" display="inline-flex" gap="6px" align="center">
      <Icon size={15} color={TYPE_ICON_COLOR[type]} />
      <Text as="span" fontSize="13px" fontWeight={600} color="text.darkBlue">
        {getContentTypeLabel(type)}
      </Text>
    </HStack>
  );
};

export default ContentTypeBadge;
